function updateFooterHeight() {
    const footer = document.querySelector("footer"), body = document.body;
    if (footer) {
        const footerHeight = footer.offsetHeight - 2;
        body.style.marginBottom = `${footerHeight}px`, document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
    }
}

!function($, window, document) {
    const $win = $(window);
    $(document), $(document.body);
    function customCursor() {
        $(".cursor").remove(), $(".js-view-zone, .js-next-zone, .js-prev-zone").off("mouseenter mouseleave mousemove"), 
        $(".js-view-zone").each((function(i, el) {
            var $el = $(el), cursor = $("<span></span>").addClass("cursor");
            $el.append(cursor), $el.on("mouseleave", (function() {
                cursor.removeClass("view arrow left");
            })), $el.on("mousemove", (function(event) {
                var $target = event.target, offset = $el.offset(), x = event.pageX - offset.left - cursor.width() / 2, y = event.pageY - offset.top - cursor.height() / 2;
                cursor.css({
                    left: x + "px",
                    top: y + "px"
                }), ($($target).hasClass("js-view-zone") || $($target).parents(".js-view-zone").length > 0) && cursor.removeClass("arrow left").addClass("view"), 
                ($($target).hasClass("js-prev-zone") || $($target).parents(".js-prev-zone").length > 0) && cursor.addClass("arrow left").removeClass("view"), 
                ($($target).hasClass("js-next-zone") || $($target).parents(".js-next-zone").length > 0) && cursor.addClass("arrow").removeClass("view");
            }));
        })), $(".js-next-zone").each((function(i, el) {
            var $el = $(el);
            if (!$el.parents(".js-view-zone").length) {
                var cursor = $("<span></span>").addClass("cursor");
                $el.append(cursor), $el.on("mouseenter", (function() {
                    cursor.removeClass("arrow view"), cursor.addClass("arrow");
                })), $el.on("mouseleave", (function() {
                    cursor.removeClass("arrow");
                })), $el.on("mousemove", (function(event) {
                    var offset = $el.offset(), x = event.pageX - offset.left - cursor.width() / 2, y = event.pageY - offset.top - cursor.height() / 2;
                    cursor.css({
                        left: x + "px",
                        top: y + "px"
                    });
                }));
            }
        })), $(".js-prev-zone").each((function(i, el) {
            var $el = $(el);
            if (!$el.parents(".js-view-zone").length) {
                var cursor = $("<span></span>").addClass("cursor");
                $el.append(cursor), $el.on("mouseenter", (function() {
                    cursor.removeClass("arrow view left"), cursor.addClass("arrow left");
                })), $el.on("mouseleave", (function() {
                    cursor.removeClass("arrow left");
                })), $el.on("mousemove", (function(event) {
                    var offset = $el.offset(), x = event.pageX - offset.left - cursor.width() / 2, y = event.pageY - offset.top - cursor.height() / 2;
                    cursor.css({
                        left: x + "px",
                        top: y + "px"
                    });
                }));
            }
        }));
    }
    function setBoxesSize(slider, refresh) {
        $(slider).find(".box").each(((_, el) => {
            const $el = $(el);
            $el.css("width", "auto");
            const mediaWidth = $el.find(".box__media").outerWidth();
            $el.css("width", mediaWidth);
        })), refresh && $(slider).slick("setPosition");
    }
    function handleResize() {
        $(".slider__slides").each(((_, slider) => setBoxesSize(slider, !0))), $(".slider__slides").each(((_, slider) => setBoxesSize(slider, !0))), 
        function observeSliders() {
            const observer = new IntersectionObserver(((entries, observer) => {
                let delay = 0;
                entries.forEach((entry => {
                    entry.isIntersecting && (initSlider(entry.target, delay), delay += 600, observer.unobserve(entry.target));
                }));
            }), {
                root: null,
                rootMargin: "0px 0px",
                threshold: .1
            });
            $(".js-slider-projects").each(((_, el) => observer.observe(el)));
        }();
    }
    function initMediaCarousels() {
        $(".media__carousel").length && $(".media__carousel").each(((key, carousel) => {
            !function initMediaCarouselTimer($carousel) {
                requestAnimationFrame(animateCarousel);
            }($(carousel));
        }));
    }
    function multiSlideAdaptiveHeight(slider) {
        let activeSlides = [], tallestSlide = 0;
        setTimeout((function() {
            $(".slick-track .slick-active", slider).each((function(item) {
                activeSlides[item] = $(this).outerHeight();
            })), activeSlides.forEach((function(item) {
                item > tallestSlide && (tallestSlide = item);
            })), $(".slick-list", slider).height(tallestSlide);
        }), 10);
    }
    $(window).on("load", (function() {
        $("html").addClass("loaded");
    })), $.fn.isInViewport = function() {
        let elementTop = $(this).offset().top, elementBottom = elementTop + $(this).outerHeight(), viewportTop = $(window).scrollTop(), viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }, $(window).on("load", (function() {
        !function initFadeInUp() {
            $(".fadein-parent");
            const $itemsUp = $(".fadein-item, .fadein-items > *"), observer = new IntersectionObserver(((entries, observer) => {
                entries.forEach((entry => {
                    entry.isIntersecting && ($(entry.target).addClass("visible"), observer.unobserve(entry.target));
                }));
            }), {
                root: null,
                rootMargin: "0px",
                threshold: .1
            });
            $itemsUp.each(((index, element) => {
                observer.observe(element);
            }));
        }(), initMediaCarousels();
    })), $win.on("ajaxInitSliders", (function() {
        customCursor();
    })), $win.on("resize", (function() {
        handleResize();
    })), $win.on("load", (function() {
        $(".header").addClass("difference"), function isTouchDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        }() && $("body").addClass("touchdevice"), customCursor();
    })).on("resize", (function() {
        var $element = $(".header");
        initMediaCarousels(), $element.hide(), $element[0].offsetHeight, $element.show();
    })), $(".js-toggle").on("click", (function(e) {
        e.preventDefault(), $("body").toggleClass("header-open"), $(this).toggleClass("active"), 
        $(this).hasClass("active") ? $(".header").removeClass("difference") : setTimeout((function() {
            $(".header").addClass("difference");
        }), 500);
    })), $(document).on("focus", ".form input", (function() {
        $(this).parents(".gfield").addClass("focus");
    })), $(document).on("focusout", ".form input", (function() {
        $(this).parents(".gfield").removeClass("focus");
    })), $(document).on("change", ".form input", (function() {
        $(this).val() ? $(this).parents(".gfield").addClass("filled") : $(this).parents(".gfield").removeClass("filled");
    })), $win.on("resize", (function() {
        multiSlideAdaptiveHeight(slider);
    })), function initDefSlider() {
        if ($(".js-slider-def .slider__slide").length <= 1) return;
        $(".js-slider-def .slider__slides").on("init", (function(slick) {
            multiSlideAdaptiveHeight(this);
        })).on("beforeChange", (function(slick, currentSlide, nextSlide) {
            multiSlideAdaptiveHeight(this);
        })).slick({
            slidesToShow: 1,
            infinite: !0,
            slidesToScroll: 1,
            arrows: !0,
            prevArrow: '<button class="js-prev-zone slick-prev"></button>',
            nextArrow: '<button class="js-next-zone slick-next"></button>',
            autoplay: !0,
            adaptiveheight: !0,
            speed: 200,
            autoplaySpeed: 2e3,
            fade: !0,
            dots: !1,
            responsive: [ {
                breakpoint: 1024,
                settings: {
                    pauseOnFocus: !1,
                    pauseOnHover: !1
                }
            } ]
        });
    }(), $win.on("load", (function() {
        var columns = $('[class^="col-"], [class^="offset-"]');
        $(columns).each((function(i, el) {
            $(el)[0].children.length || $(el).addClass("hidden-xs");
        }));
    })), $win.on("resize", (function() {
        multiSlideAdaptiveHeight(slider);
    })), $(".js-prev-zone,.js-next-zone").on("click", (function(e) {
        e.preventDefault();
    }));
}(jQuery, window, document), document.addEventListener("DOMContentLoaded", (() => {
    const fadeUpElements = document.querySelectorAll(".efr-fade-up"), fadeUpObserver = new IntersectionObserver((entries => {
        entries.forEach((entry => {
            entry.isIntersecting ? entry.target.classList.add("intersect") : entry.target.classList.remove("intersect");
        }));
    }), {
        threshold: .1
    });
    fadeUpElements.forEach((el => fadeUpObserver.observe(el)));
})), document.addEventListener("DOMContentLoaded", updateFooterHeight), window.addEventListener("resize", updateFooterHeight);